import { RouteObject } from "react-router-dom";
import TributacaoView from "./Tributacao/Tributacao.View";
import TributacaoCadastroView from "./Tributacao/Cadastro/TributacaoCadastro.View";
import TributacaoCfopView from "./Cfop/TributacaoCfop.View";
import TributacaoCfopCadastroView from "./Cfop/Cadastro/TributacaoCfopCadastro.View";
import TributacaoCfopImpostoCadastroView from "./Imposto/Cadastro/TributacaoCfopImpostoCadastro.View";

export const TributacaoRoutes: RouteObject[] = [
  {
    path: "fiscal/tributacao",
    element: <TributacaoView />,
  },
  {
    path: "fiscal/tributacao/cadastro",
    element: <TributacaoCadastroView />,
  },
  {
    path: "fiscal/tributacao/cfop",
    element: <TributacaoCfopView />,
  },
  {
    path: "fiscal/tributacao/cfop/cadastro",
    element: <TributacaoCfopCadastroView />,
  },
  {
    path: "fiscal/tributacao/cfop/imposto/cadastro",
    element: <TributacaoCfopImpostoCadastroView />,
  },
];
